import type React from "react";

import { useRoutes } from "react-router-dom";

import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import { ResourceView } from "./views/ResourceView";

export const WikiRoutes: React.FC = () => {
  const offsetTop = usePageContentOffsetTop();
  const routes = useRoutes([
    {
      path: "/",
      element: (
        <Container $pageContentOffsetTop={offsetTop}>
          <ResourceView />
        </Container>
      ),
    },
  ]);

  return routes;
};
